// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-module--tag--9tJmL"};